import { render } from "./MfaGoogle.vue?vue&type=template&id=364f0384&scoped=true"
import script from "./MfaGoogle.vue?vue&type=script&lang=js"
export * from "./MfaGoogle.vue?vue&type=script&lang=js"

import "./MfaGoogle.vue?vue&type=style&index=0&id=364f0384&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364f0384"]])

export default __exports__